import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { taskService } from '../../services/api';

// Obtener la URL base de la API de las variables de entorno
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const ChatList = ({ currentUser }) => {
  const [chatUsers, setChatUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    if (!currentUser) return;
    
    // Cargar usuarios con los que tienes chats activos
    const fetchChatUsers = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        // Obtener tareas donde eres el creador o colaborador
        const response = await fetch(`${API_URL}/tasks`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.ok) {
          const tasksData = await response.json();
          
          // Extraer usuarios únicos de las tareas
          const userIds = new Set();
          const users = [];
          
          tasksData.tasks.forEach(task => {
            // Si eres el creador, añadir al colaborador
            if (task.createdBy.id === currentUser.id && task.acceptedBy) {
              if (!userIds.has(task.acceptedBy.id)) {
                userIds.add(task.acceptedBy.id);
                users.push({
                  id: task.acceptedBy.id,
                  name: task.acceptedBy.name,
                  taskId: task._id
                });
              }
            }
            
            // Si eres el colaborador, añadir al creador
            if (task.acceptedBy === currentUser.id) {
              if (!userIds.has(task.createdBy.id)) {
                userIds.add(task.createdBy.id);
                users.push({
                  id: task.createdBy.id,
                  name: task.createdBy.name,
                  taskId: task._id
                });
              }
            }
          });
          
          setChatUsers(users);
        }
      } catch (error) {
        console.error('Error al cargar usuarios de chat:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchChatUsers();
  }, [currentUser]);
  
  if (loading) {
    return (
      <div className="chat-list text-center p-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando usuarios...</span>
        </div>
      </div>
    );
  }
  
  return (
    <div className="chat-list">
      <h2>Mis Conversaciones</h2>
      
      {chatUsers.length === 0 ? (
        <p>No tienes conversaciones activas.</p>
      ) : (
        <ul>
          {chatUsers.map(user => (
            <li key={user.id}>
              <Link to={`/chat/${user.id}`}>
                <div className="chat-user">
                  <div className="user-avatar">
                    {user.name.charAt(0).toUpperCase()}
                  </div>
                  <div className="user-info">
                    <span className="user-name">{user.name}</span>
                    <span className="task-id">Tarea: {user.taskId}</span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ChatList;
